<template>
    <div>
        <card-header title="Conference Registrations" icon="fa-presentation"/>

        <card-body>
            <card-list>

                <subheader-list-item title="Active Conferences" badge="3" icon="fa-presentation"/>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../components/common/CardHeader";
    import CardBody from "../../components/common/CardBody";
    import CardList from "../../components/common/CardList";
    import SearchListItem from "../../components/common/SearchListItem";
    import SubheaderListItem from "../../components/common/SubheaderListItem";
    import MenuListItem from "../../components/MenuListItem";

    export default {
        components: {CardHeader, CardBody, CardList, SubheaderListItem, SearchListItem, MenuListItem},

        props: ['card', 'child'],
        data() {
            return {

            }
        },
        methods: {
            load: function() {
                this.setActive();
            },
            reload: function() {
                this.load();
            },
        },
        mounted: function() {
            this.load();
        }
    }
</script>

<style lang="scss" scoped>

</style>
